var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"px-3 py-3",attrs:{"color":_vm.$vuetify.theme.dark ? '#1A2A3E' : '#E8F1F8'}},[_c('apexChart',{staticClass:"liveTradeChart",attrs:{"width":"100%","height":"338px","type":"bar","options":_vm.options,"series":_vm.processedSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }